// Shared formatting utilities for LANIS forms

/**
 * Format a 10-digit phone string as (XXX) XXX-XXXX
 * Optionally append extension: (XXX) XXX-XXXX Ext: 101
 */
export function formatPhone(raw, ext) {
  if (!raw) return "";
  const digits = raw.replace(/\D/g, "");
  if (digits.length === 10) {
    const formatted = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    return ext ? `${formatted} Ext: ${ext}` : formatted;
  }
  if (digits.length === 11 && digits[0] === "1") {
    const formatted = `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
    return ext ? `${formatted} Ext: ${ext}` : formatted;
  }
  return raw; // return as-is if unrecognized format
}

/**
 * Format a date of birth as MM/DD/YYYY.
 * Handles YYYY-MM-DD (database format) and MM/DD/YYYY (already correct).
 */
export function formatDOB(raw) {
  if (!raw) return "";
  // YYYY-MM-DD → MM/DD/YYYY
  const isoMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (isoMatch) return `${isoMatch[2]}/${isoMatch[3]}/${isoMatch[1]}`;
  // Already MM/DD/YYYY or unrecognized — return as-is
  return raw;
}

/**
 * Format SSN as XXX-XX-XXXX
 */
export function formatSSN(raw) {
  if (!raw) return "";
  const digits = raw.replace(/\D/g, "");
  if (digits.length === 9) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
  }
  return raw;
}
